import React, {useRef, useState} from "react";

import {EllipsisOutlined} from "@ant-design/icons";
import {Button} from "antd";

export function ScopeRowActions({children}) {
	const [expanded, setExpanded] = useState(false);
	const leaveTimeoutRef = useRef(null);

	const cancelLeave = () => {
		clearTimeout(leaveTimeoutRef.current);
	};

	const handleLeave = () => {
		leaveTimeoutRef.current = setTimeout(() => setExpanded(false), 150);
	};

	return (
		<div style={{display: "flex", justifyContent: "flex-end", width: "100%"}}>
			<div
				style={{display: "flex", alignItems: "center", gap: "12px"}}
				onMouseEnter={cancelLeave}
				onMouseLeave={handleLeave}>
				{expanded && children}
				<Button
					style={{marginTop: 5}}
					onClick={e => e.stopPropagation()}
					onMouseEnter={() => {
						cancelLeave();
						setExpanded(true);
					}}>
					<EllipsisOutlined />
				</Button>
			</div>
		</div>
	);
}
